import { useIntl } from 'react-intl';
import { roundPrice } from 'lib/pricing_utils';
import type { Addon } from './types';
import {
  Row,
  LeftColumn,
  RightColumn,
  AddonLabel,
  AddonNameText,
} from './styles';

export const AddonPrice = (addon: Addon) => {
  const { formatMessage } = useIntl();

  if (parseFloat(addon.total) === 0) {
    return null;
  }
  const {
    name,
    unit_price_formatted: unitPriceFormatted,
    per_person: perPerson,
    guests,
    total_formatted: totalFormatted,
  } = addon;

  return (
    <Row className="two column row" data-testid="addon-checkout-summary">
      <LeftColumn className="left aligned column">
        <AddonLabel>
          <AddonNameText className="addonName">{name}</AddonNameText>
          <div className="addonBreakdown">
            <span className="addonPrice" data-testid="addon-price">
              {roundPrice(unitPriceFormatted)}
            </span>
            <span className="addonGuests" data-testid="addon-guests">
              {perPerson
                ? formatMessage({ defaultMessage: ' x {guests}' }, { guests })
                : formatMessage(
                    { defaultMessage: ' For {guests}' },
                    { guests }
                  )}
            </span>
          </div>
        </AddonLabel>
      </LeftColumn>
      <RightColumn className="column" data-testid="addon-fee">
        {totalFormatted}
      </RightColumn>
    </Row>
  );
};
